import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Plus } from "lucide-react";

interface GoogleSearchConsoleAddButtonProps {
  onSelectExisting: () => void;
  onConnectNew: () => Promise<void> | void;
  hasConnectedAccounts: boolean;
  isConnecting?: boolean;
  className?: string;
}

export function GoogleSearchConsoleAddButton({
  onSelectExisting,
  onConnectNew,
  hasConnectedAccounts,
  isConnecting = false,
  className = "",
}: GoogleSearchConsoleAddButtonProps) {
  if (!hasConnectedAccounts) {
    return (
      <Button
        variant="outline"
        size="sm"
        onClick={() => onConnectNew()}
        disabled={isConnecting}
        className={className}
      >
        {isConnecting ? (
          "Connecting…"
        ) : (
          <>
            <Plus className="h-4 w-4 mr-2" />
            Connect
          </>
        )}
      </Button>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          disabled={isConnecting}
          className={className}
        >
          {isConnecting ? (
            "Connecting…"
          ) : (
            <>
              <Plus className="h-4 w-4 mr-2" />
              Connect
            </>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={onSelectExisting}>
          Select existing account
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onConnectNew()}>
          Connect new account
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
